import { NavLink } from 'react-router-dom';
import { GoArrowRight } from "react-icons/go";
import { categories } from "./categories_data";
import React from "react";
import NoticeComponent from "../../components/NoticeComponent";
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

// export default function Category() {
//   const { t } = useTranslation();

//   return (
//     <section className="max-w-[2560px] w-full mx-auto mt-[130px] pb-[80px]">
//       <div>
//         {/* NoticeComponent 사용 부분 주석 처리됨 */}
//         {/* <NoticeComponent
//           title={t('category.section_title')}
//           content={t('category.section_content')}
//         /> */}
//         <article className="mt-[24px]">
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
//             {categories.map((category, index) => (
//               <NavLink
//                 to={category.link}
//                 className="flex flex-col justify-center items-center"
//                 key={index}
//               >
//                 <div
//                   className="flex flex-col gap-4 justify-center items-center transform transition duration-300 hover:scale-105 ease-in-out"
//                 >
//                   <div
//                     className="w-[200px] h-[200px] md:w-[250px] md:h-[250px] rounded-[24px] flex justify-center items-center"
//                     style={{ backgroundColor: category.color }}
//                   >
//                     <img
//                       src={category.image}
//                       className='w-[60px] md:w-[80px] h-auto'
//                       alt={t(`categories.${category.key}.alt`)}
//                     />
//                   </div>
//                   <div>
//                     <h3 className="text-base tracking-wide font-semibold text-[#000]">
//                       {t(`categories.${category.key}.title`)}
//                     </h3>
//                   </div>
//                 </div>
//               </NavLink>
//             ))}
//           </div>
//         </article>
//       </div>
//     </section>
//   );
// }

export default function Category() {
  const { t } = useTranslation();

  const animationVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  return (
    <motion.div className="max-w-[980px] w-full mx-auto mt-[130px] pb-[80px]"  initial="hidden"
    animate="visible"
    variants={animationVariants}
    >
      <div className="grid grid-rows-[repeat(3,_240px)] grid-cols-12 gap-6">
        {categories.map((category) => (
          <div
            key={category.key}
            className={`${
              category.size === 'large'
                ? 'col-span-6 row-span-1'
                : category.size === 'medium'
                ? 'col-span-4 row-span-1'
                : 'col-span-3 row-span-1'
            }`}
          >
            <NavLink
              to={category.link}
              className={`relative block shadow-lg w-full h-full p-4 flex items-center justify-center ${
                category.overflowHidden ? 'overflow-hidden' : ''
              }`} // overflow-hidden 조건부 적용
              style={{ background: category.gradient }}
            >
              <div className="absolute bottom-0 right-0 w-full h-[28%] bg-gradient-to-tl from-white/70 to-transparent opacity-100"></div>
              <div
                className={`absolute ${
                  category.imagePosition === 'top-left'
                    ? 'top-3 left-4'
                    : category.imagePosition === 'bottom-left'
                    ? 'bottom-4 left-4'
                    : category.imagePosition === 'bottom-left-css'
                    ? 'bottom-[45px] left-5'
                    : category.imagePosition === 'bottom-css'
                    ? 'bottom-[37px] left-4'
                    : 'bottom-4 right-4'
                }`}
              >
                <img
                  src={category.image}
                  className="w-[138px]"
                  alt={t(`categories.${category.key}.alt`)}
                />
              </div>
              <h2
                className={`absolute text-xl tracking-wide z-50 lEliceDigitalBaeum-Bd font-bold ${
                  category.textPosition === 'right'
                    ? 'bottom-4 right-1 transform -translate-x-1/2'
                    : 'bottom-4 right-4'
                }`}
                style={{ color: category.textColor }} // 텍스트 색상 적용
              >
                {t(category.title)}
              </h2>{' '}
            </NavLink>
          </div>
        ))}
      </div>
    </motion.div>
  );
}
